import React from "react";
import { FormControl } from "react-bootstrap";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, ArrayHelper, DepartmentInterface, UserHelper } from "../../helpers";
import { Navigate } from "react-router-dom";

interface Props {
  showAffiliate: (accountId: number) => void
}

export const AdminAccounts: React.FC<Props> = props => {
  const [allDepartments, setAllDepartments] = React.useState<DepartmentInterface[]>(null);
  const [searchText, setSearchText] = React.useState("");
  const [redirect, setRedirect] = React.useState("");

  const impersonate = async (departmentId: number) => {
    const department = await ApiHelper.get("/departments/impersonate/" + departmentId);

    UserHelper.departments.push(department);
    UserHelper.currentDepartment = department;
    UserHelper.departmentChanged = true;
    ApiHelper.setDefaultPermissions(UserHelper.currentDepartment.jwt);
    setRedirect("/messages");
  }

  const getRows = () => {
    const departments: DepartmentInterface[] = filterDepartments();
    const result: React.ReactElement[] = [];
    departments.forEach(d => {
      const department = d;
      result.push(<tr>
        <td>{d.accountName}</td>
        <td>{d.name}</td>
        <td>
          <a href="about:blank" onClick={(e) => { e.preventDefault(); impersonate(department.id) }} ><i className="fas fa-user-secret" /></a>
          &nbsp;
          <a href="about:blank" onClick={(e) => { e.preventDefault(); props.showAffiliate(department.accountId) }} ><i className="fas fa-money-bill-wave" /></a>
        </td>
      </tr>);
    });
    return result;
  }

  const filterDepartments = () => {
    if (searchText === "") return ArrayHelper.limit(allDepartments, 15);
    else {
      const v = searchText.toLowerCase();
      const departments: DepartmentInterface[] = []
      for (const department of allDepartments) {
        if (department.accountName.toLowerCase().indexOf(v) > -1 || department.name.toLowerCase().indexOf(v) > -1) departments.push(department);
      }
      ArrayHelper.sort(departments, "name", false);
      ArrayHelper.sort(departments, "accountName", false);
      return ArrayHelper.limit(departments, 25);
    }
  }

  const getTable = () => {
    if (allDepartments === null) return <Loading />
    else {
      return (<table className="table table-sm table-striped" style={{ marginTop: 10 }}>
        <thead>
          <tr>
            <th>Account</th>
            <th>Department</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {getRows()}
        </tbody>
      </table>);
    }
  }

  const init = () => {
    ApiHelper.get<DepartmentInterface[]>("/departments/adminList").then((data) => setAllDepartments(data || []));
  }

  React.useEffect(init, [])

  const getEditContent = () => {
    return (<FormControl size="sm" placeholder="Search" value={searchText} onChange={(e) => setSearchText(e.currentTarget.value)} />)
  }

  if (redirect !== "") return <Navigate to={redirect} replace />
  else return (
    <DisplayBox headerText="Accounts" headerIcon="fas fa-users" editContent={getEditContent()}>
      {getTable()}
    </DisplayBox>
  );
};